import React from 'react';
import { Instagram, Linkedin, Youtube, NotebookPen } from 'lucide-react';
import { FOOTER_WORDS, SOCIALS } from '../../data/content';
import { Reveal } from './Reveal';

export const Footer = () => (
  <footer className="bg-teal text-cream pt-10 md:pt-14 pb-8 overflow-hidden">
    <div className="max-w-[1500px] mx-auto px-6 md:px-12">
      <Reveal>
        <div className="flex flex-wrap gap-x-8 gap-y-3 border-b border-cream/15 pb-9">
          {FOOTER_WORDS.map((w) => (
            <span
              key={w}
              className="text-xs md:text-sm tracking-[0.24em] uppercase text-cream/70 font-medium"
            >
              {w}
            </span>
          ))}
        </div>
      </Reveal>
    </div>

    {/* Massive logo scaling across the bottom */}
    <div className="mt-9 md:mt-12 px-6 md:px-12">
      <img
        src="/assets/logo-cream.png"
        alt="The Unscene Cult"
        className="w-full max-w-[1400px] mx-auto h-auto opacity-95"
      />
    </div>

    <div className="max-w-[1500px] mx-auto px-6 md:px-12 mt-10 flex flex-col sm:flex-row items-center justify-between gap-5">
      <span className="text-[11px] tracking-[0.2em] uppercase text-cream/45">
        The Unscene Cult
      </span>

      <div className="flex items-center gap-6">
        <a
          href="mailto:create@unscenecult.com"
          data-testid="footer-email"
          className="link-underline text-[11px] tracking-[0.2em] uppercase text-cream/45"
        >
          create@unscenecult.com
        </a>
        <span className="h-3 w-px bg-cream/20" />
        <div className="flex items-center gap-4">
          <a
            href={SOCIALS.instagram}
            target="_blank"
            rel="noreferrer"
            data-testid="footer-instagram"
            aria-label="Instagram"
            className="text-cream/55 hover:text-cream transition-colors duration-300"
          >
            <Instagram size={17} strokeWidth={1.5} />
          </a>
          <a
            href={SOCIALS.linkedin}
            target="_blank"
            rel="noreferrer"
            data-testid="footer-linkedin"
            aria-label="LinkedIn"
            className="text-cream/55 hover:text-cream transition-colors duration-300"
          >
            <Linkedin size={17} strokeWidth={1.5} />
          </a>
          <a
            href={SOCIALS.youtube}
            target="_blank"
            rel="noreferrer"
            data-testid="footer-youtube"
            aria-label="YouTube"
            className="text-cream/55 hover:text-cream transition-colors duration-300"
          >
            <Youtube size={18} strokeWidth={1.5} />
          </a>
          <a
            href={SOCIALS.substack}
            target="_blank"
            rel="noreferrer"
            data-testid="footer-substack"
            aria-label="Substack"
            className="text-cream/55 hover:text-cream transition-colors duration-300"
          >
            <NotebookPen size={17} strokeWidth={1.5} />
          </a>
        </div>
      </div>
    </div>
  </footer>
);
